import React from "react";
import PageHeader from "../components/PageHeader";
import { speakers } from "../mock";

const SpeakerBios = () => {
  return (
    <div>
      <PageHeader
        title="The beautiful thing about learning is that no one can take it away from you."
        subtitle="— B.B. King"
      />
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-display text-3xl text-[#e8a13a] mb-14 text-center">
            Get to know our Speaker Brains:
          </h2>
          <div className="space-y-20">
            {speakers.map((s, idx) => (
              <div
                key={s.name}
                className={`grid md:grid-cols-5 gap-10 items-center ${
                  idx % 2 === 1 ? "md:[direction:rtl]" : ""
                }`}
              >
                <div className="md:col-span-2 [direction:ltr]">
                  <div className="aspect-square overflow-hidden border-4 border-[#e8a13a]/30">
                    <img
                      src={s.image}
                      alt={s.name}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="md:col-span-3 [direction:ltr]">
                  <h3 className="font-display text-4xl text-[#e8a13a] mb-4">{s.name}</h3>
                  <p className="text-[#d5c9a8] leading-relaxed mb-4">{s.bio}</p>
                  <p className="font-serif-italic text-[#f5f1e8] text-xl border-l-4 border-[#e8a13a] pl-4">
                    {s.topic}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpeakerBios;
